<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="用户ID" prop="pid">
                <a-input v-model="queryParam.pid" placeholder="请输入用户ID" allow-clear/>
              </a-form-item>
            </a-col> -->
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="推荐人用户ID" prop="userId">
                <a-input v-model="queryParam.userId" placeholder="请输入推荐人用户ID" allow-clear/>
              </a-form-item>
            </a-col> -->
            <a-col :md="8" :sm="24">
              <a-form-item label="会员昵称/手机号" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入会员昵称/手机号" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="推荐人昵称/手机号" prop="tNickname">
                <a-input v-model="queryParam.tNickname" placeholder="请输入推荐人昵称/手机号" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <!-- <div class="table-operations"> -->
        <!-- <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:inviteRecord:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:inviteRecord:edit']">
          <a-icon type="edit" />修改
        </a-button> -->
        <!-- <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:inviteRecord:remove']">
          <a-icon type="delete" />删除
        </a-button> -->
        <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['user:inviteRecord:export']">
          <a-icon type="download" />导出
        </a-button> -->
        <!-- <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" /> -->
      <!-- </div> -->
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 300px)'}"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
      <span slot="index" slot-scope="text, record,index">
       {{(current-1)*size+index+1}} 
      </span>
      <span slot="nickname" slot-scope="text, record">
        <a-card hoverable style="width: 133px">
        <template>
          <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" 
           v-if="record.avatar"
                :src="record.avatar" preview="图片"/>
        </template>
        <a-card-meta :title="record.nickname">
          <template #description>{{ record.mobile }}</template>
        </a-card-meta>
      </a-card>
        </span>
     
      <span slot="tNickname" slot-scope="text, record">
          <a-card hoverable style="width: 133px">
        <template>
          <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" 
           v-if="record.tAvatar"
                :src="record.tAvatar" preview="图片"/>
        </template>
        <a-card-meta :title="record.tNickname">
          <template #description>{{ record.tMobile }}</template>
        </a-card-meta>
      </a-card>
        </span>
      
        
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record, index">
          <a @click="teamMembers(record)" v-hasPermi="['user:inviteRecord:edit']">
            <a-icon type="edit" />团队成员
          </a>
          <!-- <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:inviteRecord:edit']">
            <a-icon type="edit" />修改
          </a> -->
          <!-- <a-divider type="vertical" v-hasPermi="['user:inviteRecord:remove']" />
          <a @click="handleDelete(record, index)" v-hasPermi="['user:inviteRecord:remove']">
            <a-icon type="delete" />删除
          </a> -->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageInviteRecord,listInviteRecord, delInviteRecord } from '@/api/user/inviteRecord'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'InviteRecord',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
         //索引indexs
      indexs: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        userId: null,
        pid: null,
        nickname: null,
        // mobile: null,
        tNickname: null,
        // tMobile: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '主键ID',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,                    
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
         },
        //  {
        //   title: '用户ID',
        //   dataIndex: 'pid',
        //   ellipsis: true,
        //   align: 'center'
        // },
        
        {
          title: '会员信息',
          dataIndex: 'nickname',
          scopedSlots: { customRender: 'nickname' },
          ellipsis: true,
          align: 'center',
          width: 150
        },
        // {
        //   title: '推荐用户ID',
        //   dataIndex: 'userId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '推荐人信息',
          dataIndex: 'tNickname',
          scopedSlots: { customRender: 'tNickname' },
          ellipsis: true,
          align: 'center',
          width: 150
        },
        {
          title: '直推人数',
          dataIndex: 'directPushNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '团队人数',
          dataIndex: 'teamPushNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '直推业绩',
          dataIndex: 'directAchieve',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '团队业绩',
          dataIndex: 'teamAchieve',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '加入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
          width: 100
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 120,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询用户分享关系绑定列表 */
    getList () {
      this.loading = true
     pageInviteRecord(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },
 // 查看团队成员
 teamMembers(record){
      this.$router.push({path: '/agent/inviteRecord/teamMembers',query : { pid : record.userId} })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        pid: undefined,
        nickname: undefined,
        // mobile: undefined,
        tNickname: undefined,
        // tMobile: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
        // 列表顶部删除indexs
        if(this.selectedRowKeys.length){
        const indexList = this.selectedRowKeys.map(item=>{
          return this.list.findIndex(i=>i.id === item)
        })
        this.indexs = indexList.filter(item=>item!==-1).map(ind=>{
          return (this.current - 1) * this.size + ind + 1
        })
      }
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row,index) {
      var that = this
      const ids = row.id || this.ids
      const inds = (this.current - 1) * this.size + index + 1   
      const indexs = inds || this.indexs.sort((a, b) => a - b)
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中序号为' + indexs + '的数据',
        onOk() {
          let data = []
          if(row.id){
                data.push({"id":row.id})
              }else {
                that.ids.map(id => data.push({"id":id}))
              }
          return delInviteRecord(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          // that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/inviteRecord/export', {
            ...that.queryParam
          }, `用户分享关系绑定_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
